import { a as languages } from "../../core-8vQkh0Rd.js";
import { n as extend, r as insertBefore } from "../../language-D-vtM55V.js";
import { n as clikeComment } from "../../patterns-C0vJBvXO.js";
import "./css.js";
//#region src/prism/languages/less.js
insertBefore(languages.less = extend("css", {
	"comment": clikeComment,
	"atrule": {
		pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
		inside: { "punctuation": /[():]/ }
	},
	"selector": {
		pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
		inside: { "variable": /@+[\w-]+/ }
	},
	"variable": [{
		pattern: /@[\w-]+\s*:/,
		inside: { "punctuation": /:/ }
	}, /@@?[\w-]+/],
	"property": /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
	"operator": /[/*+-]/
}), "property", { "mixin-usage": {
	pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
	lookbehind: true,
	alias: "function"
} });
//#endregion

//# sourceMappingURL=less.js.map